<script lang="ts" setup>
    const route = useRoute()

    const hasProdQuery = computed(() => {
        return !!route.query.prod
    })
    const isOnDevPage = computed(() => {
        return window?.location?.host?.includes('hoop.local') || !!route.query.dev
    })

    const isOnStagePage = computed(() => {
        return window?.location?.host?.includes('stage.hoop') || !!route.query.stage
    })

    const isOnDevOrStagePage = computed(() => {
        return isOnDevPage.value || isOnStagePage.value
    })
</script>

<template>
    <v-system-bar v-if="isOnDevOrStagePage && !hasProdQuery" app fixed class="m-0 p-0" height="20">
        <v-row>
            <v-col cols="12" class="px-2 py-0 small text-center bg-info w-full text-white">
                Sie befinden sich auf der <b>{{ isOnStagePage ? 'Stage' : 'Dev' }}</b>-Version von Hoop.
            </v-col>
        </v-row>
    </v-system-bar>
</template>

<style scoped></style>
